export default __webpack_public_path__ + "static/media/videoCover.0c78699b.png";